export default "__VITE_ASSET__bc497b60__"